module.exports = __webpack_public_path__ + "static-portal/img/59-1.99e1a78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/59-1.jpg
// module id = McrZ
// module chunks = 4